import { render, staticRenderFns } from "./model_54.vue?vue&type=template&id=19b4aae6&scoped=true"
import script from "./model_54.vue?vue&type=script&lang=js"
export * from "./model_54.vue?vue&type=script&lang=js"
import style0 from "./model_54.vue?vue&type=style&index=0&id=19b4aae6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b4aae6",
  null
  
)

export default component.exports